import { gfm } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/directives/gfm.js?vue3';
import SafeHtml from '~/vue_shared/directives/safe_html';
import { __, sprintf } from '~/locale';
import { UPDATE_COMMENT_FORM } from '~/notes/i18n';
import NoteAttachment from '/builds/gitlab/gitlab-ee/app/assets/javascripts/notes/components/note_attachment.vue?vue3';
import NoteEditedText from '/builds/gitlab/gitlab-ee/app/assets/javascripts/notes/components/note_edited_text.vue?vue3';
import AwardsList from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/awards_list.vue?vue3';
import NoteForm from '/builds/gitlab/gitlab-ee/app/assets/javascripts/rapid_diffs/app/discussions/note_form.vue?vue3';
import NoteSuggestions from '/builds/gitlab/gitlab-ee/app/assets/javascripts/rapid_diffs/app/discussions/note_suggestions.vue?vue3';
export default {
    name: 'NoteBody',
    components: {
        AwardsList,
        NoteEditedText,
        NoteAttachment,
        NoteForm,
        NoteSuggestions
    },
    directives: {
        SafeHtml,
        gfm
    },
    props: {
        note: {
            type: Object,
            required: true
        },
        saveNote: {
            type: Function,
            required: true
        },
        canEdit: {
            type: Boolean,
            required: true
        },
        isEditing: {
            type: Boolean,
            required: false,
            default: false
        },
        autosaveKey: {
            type: String,
            required: false,
            default: ''
        },
        restoreFromAutosave: {
            type: Boolean,
            required: false,
            default: false
        },
        saveNoteErrorMessages: {
            type: Object,
            required: false,
            default: ()=>UPDATE_COMMENT_FORM
        },
        isFirstNote: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'award',
        'cancel-editing',
        'input'
    ],
    computed: {
        noteBody: {
            get () {
                return this.note.editedNote ?? this.note.note;
            },
            set (value) {
                this.$emit('input', value);
            }
        },
        saveButtonTitle () {
            return this.note.internal ? __('Save internal note') : __('Save comment');
        },
        currentUserId () {
            return window.gon?.current_user_id;
        },
        hasSuggestion () {
            return this.note.suggestions?.length > 0;
        },
        isDuoFirstReviewComment () {
            if (this.note.author.user_type !== 'duo_code_review_bot') {
                return false;
            }
            return this.isFirstNote;
        },
        duoFeedbackText () {
            return sprintf(__('Rate this response %{emoji} %{separator} Mention %{codeStart}%{botUser}%{codeEnd} to continue the conversation.'), {
                separator: '•',
                codeStart: '<code>',
                botUser: `@${this.note.author.username}`,
                codeEnd: '</code>',
                emoji: '<gl-emoji data-name="thumbsup"></gl-emoji> <gl-emoji data-name="thumbsdown"></gl-emoji>'
            }, false);
        },
        defaultAwardsList () {
            return this.isDuoFirstReviewComment ? [
                'thumbsup',
                'thumbsdown'
            ] : [];
        }
    },
    safeHtmlConfig: {
        ADD_TAGS: [
            'gl-emoji'
        ]
    }
};
